import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneromatherantempo() {


const cardData = {
keyword: "Pune To Matheran Tempo Traveller Hire On Rent",
headingDescription: "Ruturaj Enterprises provides Pune To Matheran Tempo Traveller Hire On Rent for families, friends, corporate groups, tourists, school groups, and organized travel parties planning a comfortable hill-station trip. AC, luxury, 13 seater, 17 seater, and 20 seater Tempo Traveller options can be arranged for one-way journeys, round trips, weekend holidays, sightseeing, family outings, and group tours from Pune to Matheran. Travel plans can be organized around convenient Pune pickup points, passenger capacity, luggage requirements, sightseeing stops, vehicle preferences, and the group's preferred departure and return schedule.",
topPlaces: [
{
title: "Matheran Hill Station",
description: "Matheran is a popular hill station in the Western Ghats known for its pleasant atmosphere, forested surroundings, and scenic viewpoints. Since the destination is largely vehicle-free within the main hill area, a Tempo Traveller provides convenient transportation up to the appropriate access point before visitors continue their local exploration."
},
{
title: "Charlotte Lake",
description: "Charlotte Lake is one of Matheran's well-known natural attractions and offers a peaceful setting surrounded by greenery. Families and tourist groups can include the lake in their sightseeing itinerary while enjoying a planned trip from Pune with dedicated group transportation."
},
{
title: "Panorama Point",
description: "Panorama Point is a scenic viewpoint offering wide views of the surrounding hills and valleys. It is a popular stop for visitors exploring Matheran and can be included in a full-day or weekend itinerary for groups traveling from Pune."
},
{
title: "Echo Point",
description: "Echo Point is a popular Matheran viewpoint known for its valley scenery and distinctive natural surroundings. Groups can include the location during their local sightseeing schedule while using a dedicated Tempo Traveller for the Pune-to-Matheran journey."
},
{
title: "Louisa Point",
description: "Louisa Point is among Matheran's scenic viewpoints and provides beautiful views across the surrounding landscape. It is suitable for tourists, families, and friends who want to explore the hill station's natural attractions during a planned holiday."
},
{
title: "One Tree Hill Point",
description: "One Tree Hill Point is a scenic destination surrounded by the characteristic hills and forests of Matheran. Adventure enthusiasts and nature lovers can include the viewpoint in a weekend trip itinerary while traveling together from Pune."
},
{
title: "Monkey Point",
description: "Monkey Point is a popular sightseeing location in Matheran and is frequently included in local exploration routes. Families and tourist groups can plan the point as part of a broader hill-station sightseeing schedule."
},
{
title: "Porcupine Point",
description: "Porcupine Point is known for its elevated views and scenic surroundings, particularly around sunrise and sunset. Groups planning a relaxed Matheran holiday can include the viewpoint along with other nearby attractions during their stay."
},
{
title: "Alexander Point",
description: "Alexander Point offers panoramic views of the surrounding hills and valleys and is a popular destination for visitors exploring Matheran. It can be added to a family or group sightseeing itinerary along with other viewpoints and natural attractions."
},
{
title: "Ambarnath Temple",
description: "Ambarnath Temple is an important historic temple near the broader Matheran travel region and is known for its traditional stone architecture. Groups traveling from Pune can consider adding the temple as a heritage or spiritual stop before or after their Matheran visit."
}
],
services: [
{
name: "Pune to Matheran Tempo Traveller on Rent",
description: "Pune to Matheran Tempo Traveller on Rent provides dedicated group transportation for families, friends, tourists, corporate teams, and holiday groups. Vehicle capacity can be selected according to passenger count, luggage requirements, comfort preferences, travel duration, and the planned Matheran itinerary."
},
{
name: "Pune Matheran Tempo Traveller Hire",
description: "Pune Matheran Tempo Traveller Hire is suitable for groups that want to travel together from Pune without coordinating several cars. The traveller can support family holidays, weekend outings, sightseeing trips, corporate excursions, and organized group tours."
},
{
name: "Pune Matheran Tempo Traveller Booking",
description: "Pune Matheran Tempo Traveller Booking allows travelers to organize their group transportation before the planned journey. Pickup location, passenger strength, vehicle capacity, AC preference, sightseeing requirements, departure time, and return schedule can be considered while planning the trip."
},
{
name: "AC Tempo Traveller Pune to Matheran",
description: "AC Tempo Traveller Pune to Matheran provides a comfortable road travel option for groups making the journey from Pune toward the hill station. It is suitable for families, tourists, corporate teams, and friends planning a full-day or weekend excursion."
},
{
name: "Luxury Tempo Traveller Pune to Matheran",
description: "Luxury Tempo Traveller Pune to Matheran is suitable for groups looking for a more premium and comfortable travel experience. It can be considered for family holidays, corporate outings, special trips, weekend tours, and organized sightseeing programs."
},
{
name: "13 Seater Tempo Traveller Matheran",
description: "13 Seater Tempo Traveller Matheran is a practical option for medium-sized families, friends, and small tourist groups planning a Matheran holiday. The vehicle allows the group to travel together from Pune with suitable space for passengers and essential luggage."
},
{
name: "17 Seater Tempo Traveller Matheran",
description: "17 Seater Tempo Traveller Matheran is suitable for larger families, corporate groups, school parties, and organized tourist groups. It provides common transportation for groups that require more seating while planning a direct trip or extended sightseeing itinerary."
},
{
name: "20 Seater Tempo Traveller Matheran",
description: "20 Seater Tempo Traveller Matheran provides additional seating capacity for larger travel parties visiting the hill station. It can be used for family tours, group holidays, corporate outings, weekend trips, and sightseeing programs from Pune."
},
{
name: "Pune Matheran Family Trip Traveller",
description: "Pune Matheran Family Trip Traveller provides convenient group transportation for families planning a relaxing hill-station holiday. The journey can be organized around suitable pickup points, sightseeing plans, rest breaks, luggage needs, and the group's preferred return schedule."
},
{
name: "Pune Matheran Group Travel Traveller",
description: "Pune Matheran Group Travel Traveller is ideal for friends, relatives, community groups, and organized travel parties. A dedicated vehicle keeps everyone together and makes coordination easier during the journey from Pune and while managing the overall travel itinerary."
},
{
name: "Pune Matheran Outstation Traveller",
description: "Pune Matheran Outstation Traveller provides a suitable transportation option for groups traveling beyond Pune for a planned hill-station excursion. The traveller can be selected according to passenger capacity, travel duration, luggage requirements, and the group's itinerary."
},
{
name: "Pune Matheran Round Trip Tempo Traveller",
description: "Pune Matheran Round Trip Tempo Traveller covers the complete onward and return journey for groups planning a scheduled holiday. It is useful for one-day excursions, weekend trips, family tours, sightseeing programs, and group holidays requiring coordinated return transportation."
},
{
name: "Pune Matheran One Way Traveller",
description: "Pune Matheran One Way Traveller is suitable for passengers who need dedicated transportation from Pune to Matheran without a planned return journey. It can be useful for holiday transfers, family travel, event-related journeys, and travelers making onward arrangements from the destination."
},
{
name: "Affordable Tempo Traveller Pune Matheran",
description: "Affordable Tempo Traveller Pune Matheran provides a practical shared transportation solution for groups looking to manage travel expenses. Choosing a vehicle that matches the actual group size can help avoid multiple-car arrangements while keeping passengers together throughout the journey."
},
{
name: "Matheran Tour Traveller from Pune",
description: "Matheran Tour Traveller from Pune is suitable for tourists planning a dedicated hill-station tour covering viewpoints, lakes, walking routes, and natural attractions. Groups can organize the itinerary according to their available time and preferred sightseeing locations."
},
{
name: "Pune Matheran Sightseeing Traveller",
description: "Pune Matheran Sightseeing Traveller supports organized group trips where visitors want to explore several attractions during their hill-station holiday. The journey can include selected viewpoints, Charlotte Lake, heritage locations, and other attractions around the Matheran region."
},
{
name: "Pune Matheran Weekend Trip Traveller",
description: "Pune Matheran Weekend Trip Traveller is designed for families, friends, corporate teams, and tourist groups planning a short getaway from Pune. The traveller provides common transportation for the journey and can support a flexible weekend itinerary around Matheran's scenic attractions."
},
{
name: "Pune Matheran AC Traveller Rental",
description: "Pune Matheran AC Traveller Rental provides a comfortable option for groups traveling along the Pune-to-Matheran route. Air-conditioned transportation is suitable for longer road journeys, family holidays, corporate outings, tourist groups, and weekend travel."
},
{
name: "Luxury Traveller Hire Pune Matheran",
description: "Luxury Traveller Hire Pune Matheran is intended for groups seeking enhanced comfort during their hill-station journey. It can be arranged for premium family trips, corporate travel, special occasions, weekend holidays, and sightseeing tours where a higher level of comfort is preferred."
},
{
name: "Pune Matheran Tourist Traveller",
description: "Pune Matheran Tourist Traveller provides dedicated transportation for visitors exploring Matheran's viewpoints, lakes, forests, and other attractions. Groups can travel together from Pune and coordinate their sightseeing schedule around the destination's local access arrangements."
},
{
name: "Matheran Holiday Traveller from Pune",
description: "Matheran Holiday Traveller from Pune is suitable for families, friends, and organized groups planning a relaxing getaway to the hill station. The trip can be planned around weekend schedules, sightseeing preferences, luggage requirements, and convenient pickup and return arrangements."
},
{
name: "Pune Matheran Group Tour Traveller",
description: "Pune Matheran Group Tour Traveller provides dedicated transportation for organized holiday groups, friends, families, and corporate parties. A common traveller makes it easier to coordinate the Pune departure, destination access, sightseeing plans, and overall return journey."
}
],
tableData: [
["Pune to Matheran Tempo Traveller on Rent", "Pune Matheran Tempo Traveller Hire"],
["Pune Matheran Tempo Traveller Booking", "AC Tempo Traveller Pune to Matheran"],
["Luxury Tempo Traveller Pune to Matheran", "13 Seater Tempo Traveller Matheran"],
["17 Seater Tempo Traveller Matheran", "20 Seater Tempo Traveller Matheran"],
["Pune Matheran Family Trip Traveller", "Pune Matheran Group Travel Traveller"],
["Pune Matheran Outstation Traveller", "Pune Matheran Round Trip Tempo Traveller"],
["Pune Matheran One Way Traveller", "Affordable Tempo Traveller Pune Matheran"],
["Matheran Tour Traveller from Pune", "Pune Matheran Sightseeing Traveller"],
["Pune Matheran Weekend Trip Traveller", "Pune Matheran AC Traveller Rental"],
["Luxury Traveller Hire Pune Matheran", "Pune Matheran Tourist Traveller"],
["Matheran Holiday Traveller from Pune", "Pune Matheran Group Tour Traveller"]
],
whychoose: [
{
WhyChooseheading: "Convenient Hill Station Travel",
WhyChoosedescription: "A dedicated Tempo Traveller allows families and groups to travel together from Pune toward Matheran without managing several private cars. The journey can be organized around convenient pickup points, passenger capacity, luggage needs, sightseeing plans, and preferred travel timings."
},
{
WhyChooseheading: "Ideal for Weekend Getaways",
WhyChoosedescription: "Matheran is well suited to short holidays and weekend excursions from Pune. Groups can plan an itinerary around the hill station's viewpoints, lakes, forest surroundings, and leisure activities while using common transportation for the main road journey."
},
{
WhyChooseheading: "Multiple Seating Options",
WhyChoosedescription: "Different travel parties require different amounts of seating, so 13, 17, and 20 seater Tempo Traveller options can be considered according to group size. Selecting an appropriately sized vehicle helps maintain a practical balance between passenger comfort and transportation requirements."
},
{
WhyChooseheading: "Comfortable AC Travel",
WhyChoosedescription: "AC Tempo Traveller options provide a comfortable environment for families, tourists, corporate teams, and friends traveling from Pune. This is particularly useful when the group is planning a longer sightseeing day or weekend journey with multiple stops."
},
{
WhyChooseheading: "Suitable for Family Holidays",
WhyChoosedescription: "Families can travel together while planning a relaxed Matheran holiday around their preferred sightseeing schedule. A dedicated traveller makes it easier to coordinate children, elderly passengers, luggage, meal breaks, and destination transfers."
},
{
WhyChooseheading: "Useful for Tourist Groups",
WhyChoosedescription: "Tourist groups can organize transportation around Matheran's major viewpoints and attractions while avoiding the need for separate cars from Pune. The itinerary can be structured according to the group's available time and selected sightseeing locations."
},
{
WhyChooseheading: "Luxury Travel Alternatives",
WhyChoosedescription: "Travelers who prefer a premium journey can consider luxury-oriented Tempo Traveller options for their Matheran trip. These vehicles are suitable for special family outings, corporate groups, weekend holidays, and travelers who place greater emphasis on road-trip comfort."
},
{
WhyChooseheading: "Easy Round-Trip Coordination",
WhyChoosedescription: "Arranging the onward and return journey together simplifies planning for a Matheran holiday. The transportation schedule can be coordinated with the group's sightseeing duration and destination access arrangements, making the overall trip easier to manage."
}
]
};









const faqData = [
{
question: "Can I hire a Tempo Traveller from Pune to Matheran?",
answer: "A Tempo Traveller is a convenient option for families, friends, corporate groups, and other travelers planning a trip from Pune to Matheran. Ruturaj Enterprises can arrange suitable group transportation according to passenger count, luggage, travel dates, preferred departure time, and sightseeing plans."
},
{
question: "Is a Tempo Traveller suitable for a Matheran group trip?",
answer: "Groups can enjoy the convenience of traveling together in one dedicated Tempo Traveller instead of coordinating multiple cars. It is useful for managing pickup points, luggage, travel breaks, and the overall schedule when several people are visiting Matheran together."
},
{
question: "Can I book a Tempo Traveller for a one-day Matheran trip from Pune?",
answer: "A one-day Tempo Traveller rental can be planned for groups who want to make a short excursion from Pune to Matheran. The schedule can be organized around the departure, sightseeing priorities, available travel hours, and return journey while keeping the group together."
},
{
question: "Can families rent a Tempo Traveller for Pune to Matheran?",
answer: "Family groups can choose a Tempo Traveller when traveling with children, parents, or relatives. A dedicated vehicle provides a common travel arrangement and makes it easier to carry luggage while coordinating stops and sightseeing according to the family's preferred itinerary."
},
{
question: "What places can we visit in Matheran during the trip?",
answer: "A Matheran tour can include popular viewpoints and attractions such as Panorama Point, Echo Point, Charlotte Lake, Louisa Point, One Tree Hill, and other scenic locations. The sightseeing plan can be adjusted according to the group's available time and interests."
},
{
question: "Can corporate teams hire a Tempo Traveller from Pune to Matheran?",
answer: "Corporate teams can use a Tempo Traveller for employee outings, team-building activities, recreational trips, and group excursions to Matheran. Traveling together helps the team maintain a common schedule and makes transportation between Pune and the destination easier to coordinate."
},
{
question: "Can I hire an AC Tempo Traveller for a Matheran trip?",
answer: "Travelers looking for added comfort can consider an AC Tempo Traveller depending on availability and trip requirements. Ruturaj Enterprises can help select a suitable vehicle by considering the number of passengers, luggage, journey duration, and preferred comfort level."
},
{
question: "What seating capacity should I choose for a Matheran Tempo Traveller?",
answer: "The ideal seating capacity depends on the number of travelers and the amount of luggage being carried. Smaller groups can select a suitable compact option, while larger parties can choose a higher-capacity Tempo Traveller based on passenger requirements and comfort expectations."
},
{
question: "Can we hire the Tempo Traveller for local sightseeing around Matheran?",
answer: "A Tempo Traveller rental can be planned around the group's complete transportation requirements, including suitable travel and sightseeing arrangements. Since vehicle access and local transportation rules can vary around Matheran, the itinerary can be coordinated according to permitted routes and available arrangements."
},
{
question: "Why choose Ruturaj Enterprises for Pune to Matheran Tempo Traveller rental?",
answer: "Ruturaj Enterprises offers group transportation for travelers planning leisure trips from Pune to destinations such as Matheran. Vehicle selection can be matched with passenger count, luggage, travel duration, sightseeing plans, and comfort requirements, helping the group maintain an organized journey from departure to return."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Rohit Pawar",
feedback:
"We hired a Tempo Traveller from Ruturaj Enterprises for our Pune to Matheran trip with friends. Traveling together made the journey much easier, and we could coordinate our sightseeing plans without arranging separate cars. The overall transportation experience was convenient for our group.",
rating: 5
},
{
id: 2,
name: "Miss. Neha Kulkarni",
feedback:
"Our family planned a Matheran outing from Pune and selected Ruturaj Enterprises for the Tempo Traveller rental. The dedicated vehicle was helpful for keeping everyone together and managing our luggage throughout the trip. We had a pleasant and well-organized travel experience.",
rating: 5
}
];









































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune To Matheran Tempo Traveller Hire On Rent",
  "image": "https://ruturajenterprises.com/assets/images/pune-to-matheran-tempo-traveller-hire-on-rent.webp",
  "description":
    "Pune To Matheran Tempo Traveller Hire On Rent for family holidays, group trips, weekend getaways, corporate outings, and sightseeing journeys. Ruturaj Enterprises provides comfortable AC and luxury Tempo Traveller options from Pune to Matheran in suitable seating capacities, with experienced drivers, convenient pickup arrangements, flexible rental plans, and dependable travel support for one-day as well as multi-day Matheran tours.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/pune-to-matheran-tempo-traveller-hire-on-rent"
  }
};








    return (
        <div>
<Helmet>
  <title>
    Pune To Matheran Tempo Traveller Hire On Rent | Pune Matheran Tempo Traveller | +91 9763381382
  </title>

  <meta
    name="description"
    content="Pune To Matheran Tempo Traveller Hire On Rent for family trips, group tours, weekend getaways, corporate outings and sightseeing. Choose comfortable AC and luxury Tempo Travellers in 13, 17 and 20 seater options."
  />

  <meta
    name="keywords"
    content="Pune to Matheran Tempo Traveller on Rent, Pune Matheran Tempo Traveller Hire, Pune Matheran Tempo Traveller Booking, AC Tempo Traveller Pune to Matheran, Luxury Tempo Traveller Pune to Matheran, 13 Seater Tempo Traveller Matheran, 17 Seater Tempo Traveller Matheran, 20 Seater Tempo Traveller Matheran, Pune to Matheran Tempo Traveller Rental, Pune to Matheran Tempo Traveller Hire, Pune to Matheran Tempo Traveller Booking, Pune Matheran AC Tempo Traveller Rental, Pune Matheran Luxury Tempo Traveller Rental, Pune Matheran Tourist Tempo Traveller, Pune Matheran Group Travel Tempo Traveller, Pune Matheran Family Trip Tempo Traveller, Pune Matheran One Day Trip Tempo Traveller, Pune Matheran Weekend Trip Tempo Traveller, Pune Matheran Tour Package by Tempo Traveller, Matheran Tour Package from Pune by Tempo Traveller, Pune to Matheran Tourist Tempo Traveller, Pune to Matheran Outstation Tempo Traveller, Pune to Matheran One Way Tempo Traveller, Pune to Matheran Round Trip Tempo Traveller, 13 Seater Tempo Traveller Pune to Matheran, 17 Seater Tempo Traveller Pune to Matheran, 20 Seater Tempo Traveller Pune to Matheran, 12 Seater Tempo Traveller Pune to Matheran, 14 Seater Tempo Traveller Pune to Matheran, 26 Seater Tempo Traveller Pune to Matheran, AC Tempo Traveller on Rent Pune to Matheran, Luxury Tempo Traveller on Rent Pune to Matheran, Tempo Traveller for Matheran Family Tour Pune, Tempo Traveller for Matheran Group Tour Pune, Tempo Traveller for Matheran Weekend Trip Pune, Tempo Traveller for Matheran One Day Tour Pune, Tempo Traveller for Matheran Corporate Trip Pune, Tempo Traveller for Matheran Picnic Pune, Tempo Traveller for Matheran School Trip Pune, Tempo Traveller for Matheran College Trip Pune, Tempo Traveller for Matheran Sightseeing Pune, Matheran Sightseeing Tempo Traveller from Pune, Matheran Tourist Tempo Traveller Rental Pune, Matheran Group Tour Tempo Traveller Pune, Matheran Family Tour Tempo Traveller Pune, Pune to Matheran Tempo Traveller for Group Travel, Pune to Matheran Tempo Traveller for Family Trip, Pune to Matheran Tempo Traveller for Corporate Travel, Pune to Matheran Tempo Traveller for Picnic, Pune Matheran Tempo Traveller Service, Pune Matheran Tempo Traveller Rental Service, Pune Matheran Tempo Traveller Booking Service, Affordable Pune to Matheran Tempo Traveller, Tempo Traveller Rental Near Me Pune, Ruturaj Enterprises Pune Matheran Tempo Traveller Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/43.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Puneromatherantempo ;